const normalizeList = (values?: string[]): string[] => {
    if (!values || values.length === 0) {
        return [];
    }
    const filtered = values.filter((value) => !!value);
    return Array.from(new Set(filtered)).sort();
};

export default normalizeList;
